export const inventoryScannerState = {
    name: 'app.inventoryScanner',
    url: '/inventory-scanner',
    component: 'inventoryScanner',
    onEnter: ($ngRedux) => {
        $ngRedux.dispatch({type: 'SCANNER_RESET'});
    }
};
inventoryScannerState.onEnter.$inject = ['$ngRedux'];
